export default "__VITE_ASSET__B9fBbxy3__"